import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Container,
    Grid,
    Modal,
    Paper,
    TextField,
    Typography
} from "@material-ui/core";
import {Alert, Pagination} from "@material-ui/lab";

const FilterListModal = ({ open, handleClose, modalData, filterList, data, cardClasses, classes, handleSubmit, page, setPage, filterLoading, skipVal, setSkipVal, limit }) => {
    const [searchVal, setSearchVal] = useState('');
    const handleSearch = event => {
        event.persist();
        setSearchVal(event.target.value);
    }
    const { type, description } = data;

    if (open === '') {
        return null;
    }
    return (
        <Modal
            open={open === filterList.id}
            onClose={handleClose}
        >
            {open === filterList.id ? (
                <Container className={classes.modal} maxWidth={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6">{description[0].value}</Typography>
                            <Typography
                                variant="body1">Type: {filterList.field} - {type}</Typography>
                        </Grid>
                        {filterLoading ? (
                            <Grid item xs={12}>
                                <Paper className={cardClasses.paper}>
                                    <div className={classes.loadingBar}>
                                        <CircularProgress
                                            size={50}
                                            thickness={4}
                                        />
                                    </div>
                                </Paper>
                            </Grid>
                        ) : null}
                        {!filterLoading ? (
                            <>
                                <Grid item xs={12}>
                                    <form id="modal-form" onSubmit={(e) => handleSubmit(e, searchVal)}>
                                        <Paper className={cardClasses.paper}>
                                            <Grid container spacing={2} justify="center"
                                                  alignItems="center">
                                                <Grid item xs={9}>
                                                    <TextField
                                                        id="modal-search"
                                                        name="search"
                                                        label="Search"
                                                        value={searchVal}
                                                        onChange={handleSearch}
                                                        autoFocus
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Button type="submit" variant="contained"
                                                            color="secondary" fullWidth>
                                                        Search
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </form>
                                </Grid>
                                {modalData.totalCount === 0 || !modalData.nodes.length ? (
                                    <Grid item xs={12}>
                                        <Paper className={cardClasses.paper}>
                                            <Alert severity="error">There are no matches!</Alert>
                                        </Paper>
                                    </Grid>
                                ) : (
                                    <>
                                        <Grid item xs={12}>
                                            <Box padding={2} className={classes.modalContent}>
                                                <Grid container>
                                                    {modalData.nodes.length && modalData.nodes.map((item) => (

                                                        <Grid item xs={12} md={6} key={item.id}>
                                                            <Typography variant="subtitle1">
                                                                {item.value}
                                                            </Typography>
                                                        </Grid>

                                                    ))}
                                                </Grid>
                                            </Box>
                                        </Grid>
                                        <Grid container spacing={3} item xs={12}
                                              alignItems="center">
                                            <Grid item xs={4}>
                                                <Typography
                                                    variant="body2">Displaying {skipVal + 1}-{(skipVal + limit) > modalData.totalCount ? modalData.totalCount : skipVal + limit} of {modalData.totalCount}</Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                {modalData.numberOfPages > 1 ? (
                                                    <Pagination
                                                        count={modalData.numberOfPages}
                                                        showFirstButton
                                                        showLastButton
                                                        color="primary"
                                                        onChange={(e, value) => {
                                                            setPage(value);
                                                            setSkipVal(limit * (value - 1));
                                                        }}
                                                        page={page}
                                                    />
                                                ) : null}
                                            </Grid>
                                        </Grid>
                                    </>
                                )}
                            </>
                        ) : null}
                    </Grid>
                </Container>
            ) : <div></div>}
        </Modal>
    );
};

export default FilterListModal;
